import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Text } from '../../../../../foundations';
import { Divider } from '../../../../../layout';
import { ControllerInputSelect, InputTextCleaner } from '../../../../../forms';
import { ControllerInputDateSelect } from '../../../../../forms/react-hook-form';
import styles from '../DocumentationRequired.module.css';
import { FormDataApis, SelectOptions } from '../../../ApisForm.model';
import { REGEXP_DOCS, VisaDocumentProps } from '../DocumentationRequired.model';
import { ApisFormContext, getModelInfant, containsApisError, minMaxDateExpiryDate } from '../../../ApisForm.utils';
import { useContext, useEffect } from 'react';
import { ApisError, DocVisaFields } from '../../../ApisForm.constants';
import clsx from 'clsx';

export const VisaDocuments = ({ options, isOptional, isInfant = false }: VisaDocumentProps) => {
	const { t } = useTranslation(['documentation-required', 'common']);
	const { register, setValue } = useFormContext<FormDataApis>();
	const { minDate, maxDate } = minMaxDateExpiryDate();
	const { isFormDisabled = false, apisErrors, id } = useContext(ApisFormContext);
	const visaRequired = containsApisError(apisErrors, ApisError.TM_VISA_REQUIRED);
	const modelInfant = getModelInfant(isInfant);

	useEffect(() => {
		if (options?.visaDocsTypes.value) setValue(`${modelInfant}${DocVisaFields.TYPE}`, options.visaDocsTypes);
	}, []);

	return (
		<div className={styles.box_content}>
			<Divider variant="dashed-light-gray" className={styles.box_divider} />
			<Text
				as="h4"
				font="iberia-headline"
				className={clsx([styles.box_title, visaRequired && styles.box_title_error])}
				id={`visa${String(id)}`}
			>
				{t('TITLE_VISA')} {visaRequired ? t('common:MANDATORY') : t('common:OPTIONAL')}
			</Text>
			<div className={styles.box_input}>
				<ControllerInputSelect
					name={`${modelInfant}${DocVisaFields.ISSUER_COUNTRY}`}
					label={t('DOCUMENT_VALID_COUNTRY')}
					options={options?.countries as SelectOptions[]}
					rules={{ required: isOptional ? undefined : t('DOCUMENT_COUNTRY_REQUIRED_ERROR') }}
					disabled={isFormDisabled}
				/>
			</div>
			{/* Input num documento */}
			<div className={styles.box_input}>
				<InputTextCleaner
					{...register(`${modelInfant}${DocVisaFields.NUMBER}`, {
						required: isOptional ? undefined : t('GENERAL_INPUT_REQUIRED_ERROR')
					})}
					name={`${modelInfant}${DocVisaFields.NUMBER}`}
					label={t('DOCUMENT_NUMBER')}
					regexCleaner={REGEXP_DOCS}
					maxLength={15}
					className={styles.box_input_text}
					labelStyles={styles.labelStyles}
					disabled={isFormDisabled}
				/>
			</div>
			{/* select fecha caducidad */}
			<div className={styles.box_input}>
				<ControllerInputDateSelect
					name={`${modelInfant}${DocVisaFields.EXPIRY_DATE}`}
					label={t('EXPIRY_DATE')}
					rules={{ required: isOptional ? undefined : t('GENERAL_INPUT_REQUIRED_ERROR') }}
					minDate={minDate}
					maxDate={maxDate}
					disabled={isFormDisabled}
				/>
			</div>
		</div>
	);
};
